import React from "react";

const Work = () => {
  return (
    <div id="work" className="container-fluid">
      <div className="container"></div>
    </div>
  );
};

export default Work;
